import { useContext, useMemo } from 'react';
import { modal_theme } from 'framework/modal/hooks/constants';
import { ModalPartialTheme, ModalTheme } from 'framework/modal/types';

import { ThemeContext } from '../../theme/context/ThemeContext';

const useModalTheme = (theme: Partial<ModalPartialTheme> = modal_theme): ModalTheme => {
  const {
    theme: {
      modal: { background, border, general },
    },
  } = useContext(ThemeContext);

  return useMemo(
    () => ({
      background: { ...background, ...theme.background },
      border: { ...border, ...theme.border },
      general: { ...general, ...theme.general },
    }),
    [background, general, border, theme]
  );
};

export default useModalTheme;
